import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Building2, Code2, LogOut, ShieldCheck } from 'lucide-react';

const OperatorSessionBar = ({ session, onDeveloper, onDepartment, onLogout }) => {
  const [departments, setDepartments] = useState([]);
  const [showDepartments, setShowDepartments] = useState(false);

  useEffect(() => {
    if (!showDepartments || departments.length) return;
    axios.get('/api/departments').then(({ data }) => setDepartments(data)).catch(() => setDepartments([]));
  }, [showDepartments, departments.length]);

  const remainingMinutes = Math.max(
    0,
    Math.ceil((new Date(session.expires_at).getTime() - Date.now()) / 60000)
  );

  return (
    <>
      <div className="fixed bottom-3 left-1/2 z-[60] flex max-w-[calc(100%-1.5rem)] -translate-x-1/2 items-center gap-1 rounded-2xl border border-blue-200 bg-white/95 p-2 shadow-xl backdrop-blur">
        <span className="hidden items-center gap-2 px-2 text-xs font-semibold text-blue-900 sm:flex"><ShieldCheck className="h-4 w-4" /> Betreiber · {remainingMinutes} Min.</span>
        <button onClick={onDeveloper} className="flex items-center gap-1 rounded-xl px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"><Code2 className="h-4 w-4" /> Developer</button>
        <button onClick={() => setShowDepartments(true)} className="flex items-center gap-1 rounded-xl px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"><Building2 className="h-4 w-4" /> Wache</button>
        <button onClick={onLogout} className="rounded-xl p-2 text-red-600 hover:bg-red-50" aria-label="Betreibersitzung beenden"><LogOut className="h-4 w-4" /></button>
      </div>

      {showDepartments && (
        <div className="fixed inset-0 z-[65] flex items-center justify-center bg-black/50 p-4" onClick={() => setShowDepartments(false)}>
          <div className="max-h-[80vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl" onClick={(event) => event.stopPropagation()}>
            <h2 className="text-xl font-bold text-gray-950">Wachabteilung öffnen</h2>
            <p className="mb-5 mt-1 text-sm text-gray-600">Ohne zusätzliches Mitarbeiter- oder Admin-Passwort.</p>
            <div className="space-y-3">
              {departments.map((department) => (
                <div key={department.id} className="rounded-xl border border-gray-200 p-4">
                  <p className="font-semibold text-gray-900">{department.name}</p>
                  <div className="mt-3 flex gap-2">
                    <button onClick={() => { onDepartment(department, false); setShowDepartments(false); }} className="flex-1 rounded-lg bg-gray-100 px-3 py-2 text-sm font-medium hover:bg-gray-200">Mitarbeiter</button>
                    <button onClick={() => { onDepartment(department, true); setShowDepartments(false); }} className="flex-1 rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700">Admin</button>
                  </div>
                </div>
              ))}
            </div>
            <button onClick={() => setShowDepartments(false)} className="mt-5 w-full rounded-lg px-4 py-2 text-sm text-gray-600 hover:bg-gray-100">Abbrechen</button>
          </div>
        </div>
      )}
    </>
  );
};

export default OperatorSessionBar;
